var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M6.52789 7.66882L11.9225 1.34011C12.1587 1.06242 12.1587 0.612497 11.9225 0.334096C11.6863 0.0563967 11.3026 0.0563967 11.0664 0.334096L6.09991 6.16082L1.13337 0.334798C0.897178 0.0570984 0.513542 0.0570984 0.276753 0.334798C0.0405617 0.612497 0.0405617 1.06312 0.276753 1.34082L5.67128 7.66952C5.90503 7.94296 6.29469 7.94296 6.52789 7.66882Z",
    fill: "#05275D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c980dde2467fd51bc5ba2b109f4b30aa.svg";
export { ForwardRef as ReactComponent };